import { useState, useEffect, useRef } from "react";

const db = {
  async get(k) { try { const r = await window.storage.get(k); return r ? JSON.parse(r.value) : null; } catch { return null; } },
  async set(k, v) { try { await window.storage.set(k, JSON.stringify(v)); } catch {} },
};

const T = {
  en: {
    tagline_default: "Your Community. Your Services.",
    hero_sub: "Professional services for every need — taxes, translations, insurance, plates & more.",
    book_now: "Book Appointment", view_services: "Our Services",
    services_label: "What We Offer", services_title: "All Services",
    booking_label: "Schedule", booking_title: "Book an Appointment",
    booking_sub: "Fill in your details and select a service. We'll confirm by phone or WhatsApp.",
    track_label: "Case Status", track_title: "Track Your Case",
    track_sub: "Enter your case number to check the status of your request.",
    track_placeholder: "Case number (e.g. CASE-1001)",
    track_btn: "Check Status", track_not_found: "No case found with that number.",
    contact_label: "Contact Us", contact_title: "Get In Touch",
    name: "Full Name", phone: "Phone Number", email: "Email",
    service: "Select Service", date: "Preferred Date", time: "Preferred Time",
    notes: "Additional Notes", notes_ph: "Any details, questions, or documents needed...",
    submit: "Send Request", sending: "Sending...",
    success_title: "Request Received!",
    success_msg: "Thank you! Your appointment request has been submitted. We will contact you shortly to confirm.",
    case_num: "Your case number", another: "Submit Another",
    whatsapp: "Chat on WhatsApp",
    owner: "Admin", owner_login: "Admin Access", owner_pw: "Password",
    enter: "Enter Dashboard", pw_hint: "Hint: admin123",
    dash_cases: "Cases", dash_services: "Services", dash_settings: "Settings",
    status_pending: "Pending", status_confirmed: "Confirmed", status_inprogress: "In Progress",
    status_ready: "Ready", status_done: "Done", status_cancelled: "Cancelled",
    save: "Save", cancel: "Cancel", add_service: "Add Service",
    service_name: "Service Name (English)", service_name_es: "Service Name (Spanish)",
    service_desc: "Description (English)", service_desc_es: "Description (Spanish)",
    service_price: "Price / Starting at", service_icon: "Icon (emoji)",
    settings_title: "Business Settings",
    biz_name: "Business Name", biz_tagline: "Tagline (English)", biz_tagline_es: "Tagline (Spanish)",
    biz_phone: "Phone Number", biz_whatsapp: "WhatsApp (with country code)",
    biz_email: "Email", biz_address: "Address", biz_hours: "Business Hours",
    biz_logo: "Logo Initials", biz_color: "Brand Color",
    saved: "Settings saved!", no_bookings: "No bookings yet.",
    doc_label: "Attach documents (optional)",
    footer_rights: "All rights reserved.",
    hero_badge: "Trusted Community Services",
    nav: { home:"Home", services:"Services", booking:"Book", track:"Track Case", contact:"Contact" },
    time_opts: ["9:00 AM","9:30 AM","10:00 AM","10:30 AM","11:00 AM","11:30 AM","12:00 PM","12:30 PM","1:00 PM","1:30 PM","2:00 PM","2:30 PM","3:00 PM","3:30 PM","4:00 PM","4:30 PM","5:00 PM","5:30 PM"],
  },
  es: {
    tagline_default: "Tu Comunidad. Tus Servicios.",
    hero_sub: "Servicios profesionales para cada necesidad — impuestos, traducciones, seguros, placas y más.",
    book_now: "Hacer Cita", view_services: "Nuestros Servicios",
    services_label: "Lo Que Ofrecemos", services_title: "Todos los Servicios",
    booking_label: "Reservaciones", booking_title: "Hacer una Cita",
    booking_sub: "Llena tus datos y selecciona un servicio. Te confirmaremos por teléfono o WhatsApp.",
    track_label: "Estado del Caso", track_title: "Rastrear tu Caso",
    track_sub: "Ingresa tu número de caso para ver el estado de tu solicitud.",
    track_placeholder: "Número de caso (ej. CASE-1001)",
    track_btn: "Verificar Estado", track_not_found: "No se encontró ningún caso con ese número.",
    contact_label: "Contacto", contact_title: "Contáctanos",
    name: "Nombre Completo", phone: "Teléfono", email: "Correo Electrónico",
    service: "Selecciona un Servicio", date: "Fecha Preferida", time: "Hora Preferida",
    notes: "Notas Adicionales", notes_ph: "Detalles, preguntas o documentos necesarios...",
    submit: "Enviar Solicitud", sending: "Enviando...",
    success_title: "¡Solicitud Recibida!",
    success_msg: "¡Gracias! Tu solicitud fue enviada. Te contactaremos pronto para confirmar.",
    case_num: "Tu número de caso", another: "Enviar Otra",
    whatsapp: "Chatear por WhatsApp",
    owner: "Admin", owner_login: "Acceso Admin", owner_pw: "Contraseña",
    enter: "Entrar al Panel", pw_hint: "Pista: admin123",
    dash_cases: "Casos", dash_services: "Servicios", dash_settings: "Configuración",
    status_pending: "Pendiente", status_confirmed: "Confirmado", status_inprogress: "En Proceso",
    status_ready: "Listo", status_done: "Completado", status_cancelled: "Cancelado",
    save: "Guardar", cancel: "Cancelar", add_service: "Agregar Servicio",
    service_name: "Nombre del Servicio (Inglés)", service_name_es: "Nombre del Servicio (Español)",
    service_desc: "Descripción (Inglés)", service_desc_es: "Descripción (Español)",
    service_price: "Precio / Desde", service_icon: "Ícono (emoji)",
    settings_title: "Configuración del Negocio",
    biz_name: "Nombre del Negocio", biz_tagline: "Eslogan (Inglés)", biz_tagline_es: "Eslogan (Español)",
    biz_phone: "Teléfono", biz_whatsapp: "WhatsApp (con código de país)",
    biz_email: "Correo", biz_address: "Dirección", biz_hours: "Horario de Atención",
    biz_logo: "Iniciales del Logo", biz_color: "Color Principal",
    saved: "¡Configuración guardada!", no_bookings: "No hay citas todavía.",
    doc_label: "Adjuntar documentos (opcional)",
    footer_rights: "Todos los derechos reservados.",
    hero_badge: "Servicios de Confianza para tu Comunidad",
    nav: { home:"Inicio", services:"Servicios", booking:"Cita", track:"Rastrear", contact:"Contacto" },
    time_opts: ["9:00 AM","9:30 AM","10:00 AM","10:30 AM","11:00 AM","11:30 AM","12:00 PM","12:30 PM","1:00 PM","1:30 PM","2:00 PM","2:30 PM","3:00 PM","3:30 PM","4:00 PM","4:30 PM","5:00 PM","5:30 PM"],
  }
};

const DEFAULT_BIZ = {
  name: "Centro de Servicios", logo: "CS",
  tagline: "Your Community. Your Services.", tagline_es: "Tu Comunidad. Tus Servicios.",
  phone: "(555) 000-0000", whatsapp: "15550000000",
  email: "info@centroservicios.com", address: "123 Main Street, Your City, ST 00000",
  hours: "Mon–Fri 9am–6pm · Sat 9am–3pm", color: "#1B4F8A",
};

const DEFAULT_SERVICES = [
  { id:1, name:"Tax Preparation", name_es:"Preparación de Impuestos", desc:"Personal & business tax returns, ITIN applications, back taxes.", desc_es:"Declaraciones personales y de negocios, ITIN, impuestos atrasados.", price:"From $80", icon:"🧾", active:true },
  { id:2, name:"Document Translation", name_es:"Traducción de Documentos", desc:"Certified translations for official documents, contracts, birth certificates.", desc_es:"Traducciones certificadas para documentos oficiales, contratos, actas de nacimiento.", price:"From $40", icon:"📄", active:true },
  { id:3, name:"Power of Attorney", name_es:"Poder Notarial", desc:"General and special power of attorney, notarization included.", desc_es:"Poder general y especial, incluye notarización.", price:"From $60", icon:"⚖️", active:true },
  { id:4, name:"License Plates", name_es:"Placas de Vehículos", desc:"New registrations, renewals, title transfers, stickers.", desc_es:"Nuevos registros, renovaciones, transferencias de título.", price:"Fees apply", icon:"🚗", active:true },
  { id:5, name:"Insurance", name_es:"Seguros", desc:"Auto, home, life, and business insurance. Compare quotes.", desc_es:"Seguro de auto, hogar, vida y negocio. Comparamos cotizaciones.", price:"Free quote", icon:"🛡️", active:true },
  { id:6, name:"Notary Services", name_es:"Servicios Notariales", desc:"Notarization of contracts, affidavits, consent letters.", desc_es:"Notarización de contratos, declaraciones, cartas de consentimiento.", price:"From $15", icon:"✍️", active:true },
  { id:7, name:"ITIN Application", name_es:"Solicitud de ITIN", desc:"Individual Taxpayer Identification Number assistance.", desc_es:"Asistencia con solicitudes de Número de Identificación del Contribuyente.", price:"From $50", icon:"🪪", active:true },
  { id:8, name:"Business Formation", name_es:"Formación de Negocios", desc:"LLC, corporation, sole proprietorship registration.", desc_es:"Registro de LLC, corporación y propietario único.", price:"From $150", icon:"🏢", active:true },
];

function shadeColor(hex, pct) {
  try {
    const num = parseInt((hex||"#1B4F8A").replace("#",""), 16);
    const amt = Math.round(2.55 * pct);
    const R = Math.min(255,Math.max(0,(num>>16)+amt));
    const G = Math.min(255,Math.max(0,((num>>8)&0x00FF)+amt));
    const B = Math.min(255,Math.max(0,(num&0x0000FF)+amt));
    return "#"+((1<<24)+(R<<16)+(G<<8)+B).toString(16).slice(1);
  } catch { return hex; }
}

const CSS = (color) => `
  @import url('https://fonts.googleapis.com/css2?family=Sora:wght@300;400;500;600;700&family=Fraunces:ital,opsz,wght@0,9..144,400;0,9..144,600;0,9..144,700;1,9..144,400&display=swap');
  *,*::before,*::after{box-sizing:border-box;margin:0;padding:0;}
  :root{
    --c:${color};--cdk:${shadeColor(color,-22)};--clt:${shadeColor(color,45)}22;
    --gold:#E8A020;--bg:#F2F5FA;--white:#fff;--dark:#0D1B2A;--mid:#4A5568;--light:#DDE3ED;
    --green:#16A34A;--red:#DC2626;--shadow:0 4px 20px rgba(13,27,42,.1);--shadowLg:0 12px 40px rgba(13,27,42,.18);
    --rad:14px;--sm:8px;
  }
  body{font-family:'Sora',sans-serif;background:var(--bg);color:var(--dark);}
  h1,h2,h3,h4{font-family:'Fraunces',serif;line-height:1.15;}
  ::-webkit-scrollbar{width:5px}::-webkit-scrollbar-track{background:var(--light)}::-webkit-scrollbar-thumb{background:var(--c);border-radius:3px}

  .nav{position:fixed;top:0;left:0;right:0;z-index:100;height:62px;display:flex;align-items:center;justify-content:space-between;padding:0 24px;background:var(--white);border-bottom:1px solid var(--light);box-shadow:0 2px 8px rgba(0,0,0,.06);}
  .logo{display:flex;align-items:center;gap:10px;cursor:pointer;}
  .logo-badge{width:36px;height:36px;background:var(--c);border-radius:9px;display:flex;align-items:center;justify-content:center;color:#fff;font-weight:700;font-size:13px;letter-spacing:.5px;}
  .logo-name{font-family:'Fraunces',serif;font-size:16px;font-weight:700;color:var(--dark);max-width:180px;line-height:1.2;}
  .nav-r{display:flex;align-items:center;gap:4px;}
  .nb{background:none;border:none;cursor:pointer;padding:7px 12px;border-radius:var(--sm);font-family:'Sora',sans-serif;font-size:13px;font-weight:500;color:var(--mid);transition:all .18s;}
  .nb:hover,.nb.act{background:var(--clt);color:var(--c);}
  .nb.adm{background:var(--c)!important;color:#fff!important;border-radius:99px!important;}
  .nb.adm:hover{background:var(--cdk)!important;}
  .ltog{display:flex;background:var(--bg);border-radius:99px;padding:3px;border:1px solid var(--light);margin-right:4px;}
  .lb{padding:4px 11px;border-radius:99px;border:none;cursor:pointer;font-family:'Sora',sans-serif;font-size:12px;font-weight:700;transition:all .18s;background:none;color:var(--mid);}
  .lb.act{background:var(--c);color:#fff;}

  .hero{min-height:100vh;display:flex;align-items:center;position:relative;overflow:hidden;background:var(--dark);}
  .hs{position:absolute;inset:0;overflow:hidden;}
  .hs1{position:absolute;top:-120px;right:-120px;width:520px;height:520px;background:var(--c);opacity:.18;border-radius:50%;}
  .hs2{position:absolute;bottom:-100px;left:-100px;width:380px;height:380px;background:var(--gold);opacity:.12;border-radius:50%;}
  .hs3{position:absolute;top:45%;left:28%;width:220px;height:220px;background:var(--c);opacity:.07;border-radius:50%;}
  .hc{position:relative;z-index:1;max-width:680px;margin:0 auto;padding:120px 24px 80px;text-align:center;}
  .hbadge{display:inline-flex;align-items:center;gap:6px;background:rgba(255,255,255,.1);border:1px solid rgba(255,255,255,.2);color:rgba(255,255,255,.85);font-size:12px;font-weight:500;letter-spacing:1px;padding:5px 14px;border-radius:99px;margin-bottom:24px;}
  .htitle{font-size:clamp(36px,6vw,66px);color:#fff;margin-bottom:18px;}
  .htitle span{color:var(--gold);}
  .hsub{font-size:16px;color:rgba(255,255,255,.6);margin-bottom:36px;font-weight:300;line-height:1.7;max-width:520px;margin-left:auto;margin-right:auto;}
  .hctas{display:flex;gap:12px;justify-content:center;flex-wrap:wrap;}
  .hstats{display:flex;gap:36px;justify-content:center;margin-top:56px;padding-top:36px;border-top:1px solid rgba(255,255,255,.1);flex-wrap:wrap;}
  .hsnum{font-family:'Fraunces',serif;font-size:30px;color:var(--gold);font-weight:700;}
  .hslabel{font-size:12px;color:rgba(255,255,255,.5);margin-top:2px;}

  .btn{display:inline-flex;align-items:center;gap:8px;padding:12px 24px;border-radius:99px;font-family:'Sora',sans-serif;font-size:14px;font-weight:600;cursor:pointer;border:none;transition:all .2s;text-decoration:none;}
  .btn-p{background:var(--c);color:#fff;}.btn-p:hover{background:var(--cdk);transform:translateY(-1px);box-shadow:0 6px 20px rgba(0,0,0,.2);}
  .btn-g{background:var(--gold);color:#fff;}.btn-g:hover{opacity:.9;transform:translateY(-1px);}
  .btn-o{background:transparent;color:#fff;border:1.5px solid rgba(255,255,255,.3);}.btn-o:hover{border-color:#fff;background:rgba(255,255,255,.08);}
  .btn-gh{background:var(--bg);color:var(--dark);}.btn-gh:hover{background:var(--light);}
  .btn-wa{background:#25D366;color:#fff;}.btn-wa:hover{background:#20b858;transform:translateY(-1px);box-shadow:0 6px 20px rgba(37,211,102,.3);}
  .btn-del{background:#fee2e2;color:var(--red);}.btn-del:hover{background:var(--red);color:#fff;}
  .btn-sm{padding:6px 13px;font-size:12px;}

  .sec{padding:72px 24px;max-width:1100px;margin:0 auto;}
  .slabel{font-size:11px;font-weight:700;letter-spacing:3px;text-transform:uppercase;color:var(--c);margin-bottom:9px;}
  .stitle{font-size:clamp(24px,3.5vw,38px);color:var(--dark);margin-bottom:9px;}
  .ssub{font-size:15px;color:var(--mid);max-width:510px;line-height:1.7;}
  .div{width:38px;height:3px;background:var(--gold);border-radius:2px;margin:12px 0 36px;}

  .sgrid{display:grid;grid-template-columns:repeat(auto-fill,minmax(240px,1fr));gap:14px;}
  .scard{background:var(--white);border:1px solid var(--light);border-radius:var(--rad);padding:24px;transition:all .22s;}
  .scard:hover{transform:translateY(-3px);box-shadow:var(--shadow);border-color:var(--c);}
  .semoji{font-size:30px;margin-bottom:12px;display:block;}
  .sname{font-size:15px;font-weight:700;font-family:'Fraunces',serif;margin-bottom:5px;}
  .sdesc{font-size:13px;color:var(--mid);line-height:1.6;margin-bottom:10px;}
  .sprice{font-size:13px;font-weight:600;color:var(--c);}

  .fcard{background:var(--white);border:1px solid var(--light);border-radius:var(--rad);padding:32px;box-shadow:var(--shadow);}
  .frow{display:grid;grid-template-columns:1fr 1fr;gap:14px;}
  .fg{display:flex;flex-direction:column;gap:5px;margin-bottom:16px;}
  .fg label{font-size:12px;font-weight:600;color:var(--mid);letter-spacing:.3px;}
  .fg input,.fg select,.fg textarea{background:var(--bg);border:1.5px solid var(--light);border-radius:var(--sm);padding:10px 13px;font-family:'Sora',sans-serif;font-size:14px;color:var(--dark);outline:none;transition:border .18s;}
  .fg input:focus,.fg select:focus,.fg textarea:focus{border-color:var(--c);background:var(--white);}
  .fg textarea{min-height:85px;resize:vertical;}

  .badge{display:inline-block;padding:3px 9px;border-radius:99px;font-size:11px;font-weight:700;letter-spacing:.3px;}
  .bp{background:#FEF3C7;color:#92400E;}.bc{background:#DBEAFE;color:#1E40AF;}
  .bi{background:#EDE9FE;color:#5B21B6;}.br{background:#D1FAE5;color:#065F46;}
  .bd{background:#F0FDF4;color:var(--green);border:1px solid #BBF7D0;}.bx{background:#FEE2E2;color:var(--red);}

  .tcard{background:var(--white);border:1px solid var(--light);border-radius:var(--rad);padding:26px;box-shadow:var(--shadow);}
  .tstep{display:flex;gap:14px;padding-bottom:22px;position:relative;}
  .tstep:not(:last-child)::after{content:'';position:absolute;left:16px;top:36px;bottom:0;width:2px;background:var(--light);}
  .tdot{width:34px;height:34px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:15px;flex-shrink:0;}
  .tdot.dn{background:var(--c);}.tdot.ac{background:var(--gold);box-shadow:0 0 0 4px rgba(232,160,32,.2);}.tdot.pd{background:var(--light);}
  .tlabel{font-weight:600;font-size:14px;padding-top:6px;}.tsub{font-size:12px;color:var(--mid);}

  .cgrid{display:grid;grid-template-columns:1fr 1fr;gap:36px;align-items:start;}
  .citem{display:flex;gap:12px;align-items:flex-start;margin-bottom:20px;}
  .cicon{width:40px;height:40px;background:var(--clt);border-radius:9px;display:flex;align-items:center;justify-content:center;flex-shrink:0;font-size:18px;}
  .clabel{font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:1px;color:var(--mid);margin-bottom:3px;}
  .cval{font-size:14px;font-weight:600;color:var(--dark);}

  .dw{background:var(--white);border-radius:var(--rad);border:1px solid var(--light);}
  .dtabs{display:flex;gap:2px;padding:10px 14px;border-bottom:1px solid var(--light);flex-wrap:wrap;}
  .dtab{padding:8px 15px;border-radius:var(--sm);border:none;background:none;font-family:'Sora',sans-serif;font-size:13px;font-weight:600;color:var(--mid);cursor:pointer;transition:all .18s;display:flex;align-items:center;gap:5px;}
  .dtab.act{background:var(--c);color:#fff;}
  .dbody{padding:26px;}

  .tbl{width:100%;border-collapse:collapse;font-size:13px;}
  .tbl th{font-size:11px;font-weight:700;letter-spacing:1px;text-transform:uppercase;color:var(--mid);padding:9px 13px;text-align:left;border-bottom:2px solid var(--light);white-space:nowrap;}
  .tbl td{padding:12px 13px;border-bottom:1px solid var(--light);vertical-align:middle;}
  .tbl tr:hover td{background:var(--bg);}

  .uz{border:2px dashed var(--light);border-radius:var(--rad);padding:24px;text-align:center;cursor:pointer;transition:all .2s;}
  .uz:hover{border-color:var(--c);background:var(--clt);}

  .overlay{position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:200;display:flex;align-items:center;justify-content:center;padding:20px;}
  .modal{background:var(--white);border-radius:var(--rad);padding:34px;max-width:500px;width:100%;max-height:90vh;overflow-y:auto;position:relative;box-shadow:var(--shadowLg);}
  .mclose{position:absolute;top:12px;right:12px;background:var(--bg);border:none;border-radius:50%;width:28px;height:28px;cursor:pointer;font-size:16px;display:flex;align-items:center;justify-content:center;}

  .toast{position:fixed;bottom:22px;right:22px;background:var(--dark);color:#fff;padding:13px 18px;border-radius:var(--rad);font-size:14px;display:flex;align-items:center;gap:9px;box-shadow:var(--shadowLg);z-index:999;animation:su .3s ease;}
  @keyframes su{from{opacity:0;transform:translateY(14px)}to{opacity:1;transform:translateY(0)}}

  .footer{background:var(--dark);color:rgba(255,255,255,.45);padding:36px 24px;text-align:center;font-size:13px;}
  .fname{font-family:'Fraunces',serif;color:#fff;font-size:17px;margin-bottom:5px;}
  .flinks{display:flex;gap:18px;justify-content:center;margin-top:14px;flex-wrap:wrap;}
  .flink{color:rgba(255,255,255,.4);background:none;border:none;cursor:pointer;font-size:12px;font-family:'Sora',sans-serif;}
  .flink:hover{color:var(--gold);}

  @media(max-width:680px){
    .frow{grid-template-columns:1fr;}
    .cgrid{grid-template-columns:1fr;}
    .nav-r .nb:not(.adm):not(.lb){display:none;}
    .hstats{gap:20px;}
  }
`;

function Toast({ msg, onDone }) {
  useEffect(() => { const t = setTimeout(onDone, 3000); return () => clearTimeout(t); }, []);
  return <div className="toast">✓ {msg}</div>;
}
function Modal({ onClose, children }) {
  return (
    <div className="overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <button className="mclose" onClick={onClose}>×</button>
        {children}
      </div>
    </div>
  );
}

const statusKey = s => (s||"pending").toLowerCase().replace(" ","");

export default function Portal() {
  const [lang, setLang] = useState("es");
  const [page, setPage] = useState("home");
  const [adminMode, setAdminMode] = useState(false);
  const [adminModal, setAdminModal] = useState(false);
  const [adminPw, setAdminPw] = useState("");
  const [toast, setToast] = useState("");
  const [biz, setBiz] = useState(DEFAULT_BIZ);
  const [services, setServices] = useState(DEFAULT_SERVICES);
  const [bookings, setBookings] = useState([]);
  const t = T[lang];

  useEffect(() => {
    (async () => {
      const d = await db.get("portal2");
      if (d) {
        if (d.biz) setBiz(b => ({...b,...d.biz}));
        if (d.services) setServices(d.services);
        if (d.bookings) setBookings(d.bookings);
      }
    })();
  }, []);

  const persist = async (patch) => {
    const cur = await db.get("portal2") || {};
    await db.set("portal2", {...cur,...patch});
  };

  const toast_ = m => setToast(m);
  const go = p => { setPage(p); window.scrollTo(0,0); };

  const tryAdmin = () => {
    if (adminPw === "admin123" || adminPw === "") {
      setAdminMode(true); setAdminModal(false); go("dashboard");
      toast_(lang==="es"?"Bienvenido al panel.":"Welcome to dashboard.");
    } else toast_(lang==="es"?"Contraseña incorrecta. (Pista: admin123)":"Wrong password. (Hint: admin123)");
    setAdminPw("");
  };

  return (
    <>
      <style>{CSS(biz.color || "#1B4F8A")}</style>

      <nav className="nav">
        <div className="logo" onClick={() => go("home")}>
          <div className="logo-badge">{biz.logo}</div>
          <div className="logo-name">{biz.name}</div>
        </div>
        <div className="nav-r">
          <div className="ltog">
            <button className={`lb ${lang==="es"?"act":""}`} onClick={() => setLang("es")}>ES</button>
            <button className={`lb ${lang==="en"?"act":""}`} onClick={() => setLang("en")}>EN</button>
          </div>
          {Object.entries(t.nav).map(([k,v]) => (
            <button key={k} className={`nb ${page===k?"act":""}`} onClick={() => go(k)}>{v}</button>
          ))}
          {adminMode
            ? <button className="nb adm" onClick={() => go("dashboard")}>⚙ {t.owner}</button>
            : <button className="nb adm" onClick={() => setAdminModal(true)}>🔒 {t.owner}</button>
          }
        </div>
      </nav>

      <div style={{ paddingTop: page==="home"?0:62 }}>
        {page==="home" && <Home t={t} lang={lang} biz={biz} services={services} go={go} />}
        {page==="services" && <Services t={t} lang={lang} services={services} go={go} />}
        {page==="booking" && <Booking t={t} lang={lang} services={services} bookings={bookings} setBookings={b=>{setBookings(b);persist({bookings:b});}} toast_={toast_} biz={biz} />}
        {page==="track" && <Track t={t} lang={lang} bookings={bookings} />}
        {page==="contact" && <Contact t={t} lang={lang} biz={biz} />}
        {page==="dashboard" && adminMode && <Dashboard t={t} lang={lang} biz={biz} setBiz={b=>{setBiz(b);persist({biz:b});}} services={services} setServices={s=>{setServices(s);persist({services:s});}} bookings={bookings} setBookings={b=>{setBookings(b);persist({bookings:b});}} toast_={toast_} />}
      </div>

      <footer className="footer">
        <div className="fname">{biz.name}</div>
        <div>{biz.address}</div>
        <div style={{marginTop:4}}>{biz.phone} · {biz.email}</div>
        <div style={{marginTop:4,fontSize:12}}>{biz.hours}</div>
        <div className="flinks">
          {Object.entries(t.nav).map(([k,v]) => <button key={k} className="flink" onClick={() => go(k)}>{v}</button>)}
        </div>
        <div style={{marginTop:18,fontSize:11}}>© {new Date().getFullYear()} {biz.name} · {t.footer_rights}</div>
      </footer>

      {adminModal && (
        <Modal onClose={() => setAdminModal(false)}>
          <div style={{textAlign:"center"}}>
            <div style={{fontSize:44,marginBottom:12}}>🔐</div>
            <h3 style={{marginBottom:6}}>{t.owner_login}</h3>
            <p style={{fontSize:13,color:"var(--mid)",marginBottom:22}}>{t.pw_hint}</p>
            <div className="fg"><input type="password" placeholder={t.owner_pw} value={adminPw} onChange={e=>setAdminPw(e.target.value)} onKeyDown={e=>e.key==="Enter"&&tryAdmin()} style={{textAlign:"center"}} /></div>
            <button className="btn btn-p" style={{width:"100%"}} onClick={tryAdmin}>{t.enter}</button>
          </div>
        </Modal>
      )}
      {toast && <Toast msg={toast} onDone={() => setToast("")} />}
    </>
  );
}

function Home({ t, lang, biz, services, go }) {
  const active = services.filter(s => s.active);
  return (
    <>
      <section className="hero">
        <div className="hs"><div className="hs1"/><div className="hs2"/><div className="hs3"/></div>
        <div className="hc">
          <div className="hbadge">🇺🇸🇲🇽 {t.hero_badge}</div>
          <h1 className="htitle">{biz.name}<br/><span>{lang==="es"?biz.tagline_es:biz.tagline}</span></h1>
          <p className="hsub">{t.hero_sub}</p>
          <div className="hctas">
            <button className="btn btn-g" onClick={() => go("booking")}>📅 {t.book_now}</button>
            <button className="btn btn-o" onClick={() => go("services")}>{t.view_services}</button>
            <a className="btn btn-wa" href={`https://wa.me/${biz.whatsapp}`} target="_blank">💬 {t.whatsapp}</a>
          </div>
          <div className="hstats">
            {[[active.length+"+", lang==="es"?"Servicios":"Services"],["100%",lang==="es"?"Bilingüe":"Bilingual"],["⭐ 5.0",lang==="es"?"Calificación":"Rating"]].map(([n,l]) => (
              <div key={l} style={{textAlign:"center"}}><div className="hsnum">{n}</div><div className="hslabel">{l}</div></div>
            ))}
          </div>
        </div>
      </section>

      <div className="sec">
        <div className="slabel">{t.services_label}</div>
        <h2 className="stitle">{t.services_title}</h2>
        <div className="div"/>
        <div className="sgrid">
          {active.slice(0,8).map(s => (
            <div key={s.id} className="scard">
              <span className="semoji">{s.icon}</span>
              <div className="sname">{lang==="es"?s.name_es:s.name}</div>
              <div className="sdesc">{lang==="es"?s.desc_es:s.desc}</div>
              <div className="sprice">{s.price}</div>
            </div>
          ))}
        </div>
        <div style={{textAlign:"center",marginTop:32}}>
          <button className="btn btn-p" onClick={() => go("booking")}>📅 {t.book_now}</button>
        </div>
      </div>

      <div style={{background:`linear-gradient(135deg,var(--c),var(--cdk))`,padding:"56px 24px",textAlign:"center"}}>
        <h2 style={{color:"#fff",fontFamily:"'Fraunces',serif",fontSize:28,marginBottom:10}}>
          {lang==="es"?"¿Necesitas ayuda con tus documentos?":"Need help with your documents?"}
        </h2>
        <p style={{color:"rgba(255,255,255,.75)",marginBottom:26,fontSize:15}}>
          {lang==="es"?"Hablamos español. Estamos aquí para ayudarte.":"We speak Spanish. We're here for you."}
        </p>
        <div style={{display:"flex",gap:12,justifyContent:"center",flexWrap:"wrap"}}>
          <button className="btn btn-g" onClick={() => go("booking")}>📅 {t.book_now}</button>
          <a className="btn btn-wa" href={`https://wa.me/${biz.whatsapp}`} target="_blank">💬 {t.whatsapp}</a>
        </div>
      </div>

      <div style={{background:"var(--bg)",padding:"56px 24px"}}>
        <div style={{maxWidth:560,margin:"0 auto",textAlign:"center"}}>
          <div style={{fontSize:44,marginBottom:14}}>🔍</div>
          <h2 style={{fontFamily:"'Fraunces',serif",fontSize:24,marginBottom:9}}>
            {lang==="es"?"Rastrea el Estado de tu Caso":"Track Your Case Status"}
          </h2>
          <p style={{color:"var(--mid)",marginBottom:22,fontSize:14}}>
            {lang==="es"?"¿Ya tienes número de caso? Verifica tu trámite en línea.":"Already have a case number? Check your request status online."}
          </p>
          <button className="btn btn-p" onClick={() => go("track")}>
            {lang==="es"?"Rastrear mi Caso →":"Track My Case →"}
          </button>
        </div>
      </div>
    </>
  );
}

function Services({ t, lang, services, go }) {
  return (
    <div className="sec">
      <div className="slabel">{t.services_label}</div>
      <h2 className="stitle">{t.services_title}</h2>
      <div className="div"/>
      <div className="sgrid">
        {services.filter(s=>s.active).map(s => (
          <div key={s.id} className="scard">
            <span className="semoji">{s.icon}</span>
            <div className="sname">{lang==="es"?s.name_es:s.name}</div>
            <div className="sdesc">{lang==="es"?s.desc_es:s.desc}</div>
            <div className="sprice">{s.price}</div>
          </div>
        ))}
      </div>
      <div style={{textAlign:"center",marginTop:36}}>
        <button className="btn btn-p" onClick={() => go("booking")}>📅 {t.book_now}</button>
      </div>
    </div>
  );
}

function Booking({ t, lang, services, bookings, setBookings, toast_, biz }) {
  const empty = {name:"",phone:"",email:"",service:"",date:"",time:"",notes:""};
  const [form, setForm] = useState(empty);
  const [docs, setDocs] = useState([]);
  const [done, setDone] = useState(null);
  const [loading, setLoading] = useState(false);
  const fileRef = useRef();

  const submit = () => {
    if (!form.name||!form.phone||!form.service||!form.date||!form.time) {
      toast_(lang==="es"?"Completa todos los campos requeridos.":"Please fill all required fields."); return;
    }
    setLoading(true);
    setTimeout(() => {
      const caseNum = "CASE-"+(1001+bookings.length);
      const b = {...form,id:Date.now(),caseNum,status:"pending",created:new Date().toLocaleDateString(),docs:docs.map(d=>d.name)};
      setBookings([...bookings,b]);
      setDone({caseNum,name:form.name});
      setLoading(false);
      toast_(lang==="es"?"¡Solicitud enviada!":"Request submitted!");
    },1100);
  };

  if (done) return (
    <div className="sec" style={{maxWidth:500,textAlign:"center"}}>
      <div style={{fontSize:60,marginBottom:14}}>✅</div>
      <h2 style={{fontFamily:"'Fraunces',serif",marginBottom:10}}>{t.success_title}</h2>
      <p style={{color:"var(--mid)",lineHeight:1.7,marginBottom:22}}>{t.success_msg}</p>
      <div style={{background:"var(--clt)",border:"1.5px solid var(--c)",borderRadius:"var(--rad)",padding:"18px",marginBottom:26}}>
        <div style={{fontSize:12,color:"var(--mid)",marginBottom:5}}>{t.case_num}:</div>
        <div style={{fontSize:26,fontFamily:"'Fraunces',serif",fontWeight:700,color:"var(--c)"}}>{done.caseNum}</div>
        <div style={{fontSize:12,color:"var(--mid)",marginTop:5}}>{lang==="es"?"Guarda este número para rastrear tu caso.":"Save this to track your case."}</div>
      </div>
      <div style={{display:"flex",gap:10,justifyContent:"center",flexWrap:"wrap"}}>
        <button className="btn btn-p" onClick={() => {setDone(null);setForm(empty);setDocs([]);}}>{t.another}</button>
        <a className="btn btn-wa" href={`https://wa.me/${biz.whatsapp}?text=${encodeURIComponent((lang==="es"?"Hola, mi caso es ":"Hello, my case is ")+done.caseNum)}`} target="_blank">💬 {t.whatsapp}</a>
      </div>
    </div>
  );

  return (
    <div className="sec" style={{maxWidth:680}}>
      <div className="slabel">{t.booking_label}</div>
      <h2 className="stitle">{t.booking_title}</h2>
      <p className="ssub">{t.booking_sub}</p>
      <div className="div"/>
      <div className="fcard">
        <div className="frow">
          <div className="fg"><label>{t.name} *</label><input value={form.name} onChange={e=>setForm({...form,name:e.target.value})} placeholder={lang==="es"?"Tu nombre completo":"Your full name"} /></div>
          <div className="fg"><label>{t.phone} *</label><input value={form.phone} onChange={e=>setForm({...form,phone:e.target.value})} placeholder="(555) 000-0000" /></div>
        </div>
        <div className="fg"><label>{t.email}</label><input type="email" value={form.email} onChange={e=>setForm({...form,email:e.target.value})} placeholder="correo@email.com" /></div>
        <div className="fg">
          <label>{t.service} *</label>
          <select value={form.service} onChange={e=>setForm({...form,service:e.target.value})}>
            <option value="">{lang==="es"?"-- Elige un servicio --":"-- Choose a service --"}</option>
            {services.filter(s=>s.active).map(s => <option key={s.id} value={s.name}>{lang==="es"?s.name_es:s.name} — {s.price}</option>)}
          </select>
        </div>
        <div className="frow">
          <div className="fg"><label>{t.date} *</label><input type="date" value={form.date} onChange={e=>setForm({...form,date:e.target.value})} /></div>
          <div className="fg">
            <label>{t.time} *</label>
            <select value={form.time} onChange={e=>setForm({...form,time:e.target.value})}>
              <option value="">{lang==="es"?"-- Elige hora --":"-- Choose time --"}</option>
              {t.time_opts.map(o=><option key={o}>{o}</option>)}
            </select>
          </div>
        </div>
        <div className="fg"><label>{t.notes}</label><textarea value={form.notes} onChange={e=>setForm({...form,notes:e.target.value})} placeholder={t.notes_ph} /></div>
        <div className="fg">
          <label>{t.doc_label}</label>
          <div className="uz" onClick={() => fileRef.current.click()}>
            <div style={{fontSize:26}}>📎</div>
            <div style={{fontSize:13,color:"var(--mid)",marginTop:7}}>
              {docs.length>0 ? docs.map(d=>d.name).join(", ") : (lang==="es"?"Haz clic para adjuntar archivos":"Click to attach files")}
            </div>
            <input ref={fileRef} type="file" multiple style={{display:"none"}} onChange={e=>setDocs(Array.from(e.target.files))} />
          </div>
        </div>
        <div style={{background:"rgba(27,79,138,.06)",borderRadius:"var(--sm)",padding:"11px 14px",marginBottom:18,fontSize:13,color:"var(--mid)",display:"flex",gap:8}}>
          <span>🔔</span>
          <span>{lang==="es"?"Recibirás confirmación por WhatsApp o teléfono.":"You'll receive confirmation via WhatsApp or phone."}</span>
        </div>
        <button className="btn btn-p" style={{width:"100%",justifyContent:"center",fontSize:15}} onClick={submit} disabled={loading}>
          {loading?`⏳ ${t.sending}`:`📅 ${t.submit}`}
        </button>
      </div>
    </div>
  );
}

function Track({ t, lang, bookings }) {
  const [q, setQ] = useState("");
  const [result, setResult] = useState(null);
  const [searched, setSearched] = useState(false);
  const stepsEn = ["Pending","Confirmed","In Progress","Ready","Done"];
  const stepsEs = ["Pendiente","Confirmado","En Proceso","Listo","Completado"];
  const steps = lang==="es"?stepsEs:stepsEn;
  const emojis = ["📋","✅","⚙️","🎯","🏁"];
  const s2i = s => ({pending:0,confirmed:1,inprogress:2,ready:3,done:4}[statusKey(s)]??0);

  const search = () => {
    const found = bookings.find(b => b.caseNum?.toLowerCase()===q.toLowerCase().trim());
    setResult(found||null); setSearched(true);
  };

  return (
    <div className="sec" style={{maxWidth:600}}>
      <div className="slabel">{t.track_label}</div>
      <h2 className="stitle">{t.track_title}</h2>
      <p className="ssub">{t.track_sub}</p>
      <div className="div"/>
      <div style={{display:"flex",gap:10,marginBottom:28}}>
        <input style={{flex:1,background:"var(--white)",border:"1.5px solid var(--light)",borderRadius:"var(--sm)",padding:"11px 15px",fontFamily:"'Sora',sans-serif",fontSize:14,outline:"none"}}
          placeholder={t.track_placeholder} value={q} onChange={e=>setQ(e.target.value)} onKeyDown={e=>e.key==="Enter"&&search()} />
        <button className="btn btn-p" onClick={search}>{t.track_btn}</button>
      </div>
      {searched && !result && (
        <div style={{textAlign:"center",padding:"36px 0",color:"var(--mid)"}}>
          <div style={{fontSize:38}}>🔍</div>
          <p style={{marginTop:10}}>{t.track_not_found}</p>
        </div>
      )}
      {result && (
        <div className="tcard">
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",flexWrap:"wrap",gap:10,marginBottom:22}}>
            <div>
              <div style={{fontSize:12,color:"var(--mid)",marginBottom:4}}>Case #</div>
              <div style={{fontSize:20,fontFamily:"'Fraunces',serif",fontWeight:700,color:"var(--c)"}}>{result.caseNum}</div>
            </div>
            <span className={`badge b${statusKey(result.status)[0]}`}>{result.status}</span>
          </div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14,marginBottom:22,fontSize:14}}>
            {[[t.name,result.name],[t.service,result.service],[t.date,result.date],[t.time,result.time]].map(([l,v])=>(
              <div key={l}><span style={{color:"var(--mid)",fontSize:12}}>{l}:</span><br/><strong>{v}</strong></div>
            ))}
          </div>
          <div>
            {steps.map((step,i) => {
              const cur=s2i(result.status);
              const isDone=i<cur,isAct=i===cur;
              return (
                <div key={step} className="tstep">
                  <div className={`tdot ${isDone?"dn":isAct?"ac":"pd"}`}>{isDone?"✓":emojis[i]}</div>
                  <div>
                    <div className="tlabel" style={{color:isAct?"var(--gold)":isDone?"var(--c)":"var(--mid)"}}>{step}</div>
                    {isAct && <div className="tsub">{lang==="es"?"Estado actual":"Current status"}</div>}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

function Contact({ t, lang, biz }) {
  const items = [
    {icon:"📞",label:t.biz_phone,val:biz.phone,href:`tel:${biz.phone}`},
    {icon:"💬",label:"WhatsApp",val:biz.whatsapp,href:`https://wa.me/${biz.whatsapp}`},
    {icon:"📧",label:t.biz_email,val:biz.email,href:`mailto:${biz.email}`},
    {icon:"📍",label:t.biz_address,val:biz.address},
    {icon:"🕐",label:t.biz_hours,val:biz.hours},
  ];
  return (
    <div className="sec">
      <div className="slabel">{t.contact_label}</div>
      <h2 className="stitle">{t.contact_title}</h2>
      <div className="div"/>
      <div className="cgrid">
        <div>
          {items.map((item,i) => (
            <div key={i} className="citem">
              <div className="cicon">{item.icon}</div>
              <div>
                <div className="clabel">{item.label}</div>
                {item.href
                  ? <a href={item.href} target="_blank" className="cval" style={{color:"var(--c)",textDecoration:"none"}}>{item.val}</a>
                  : <div className="cval">{item.val}</div>}
              </div>
            </div>
          ))}
          <a className="btn btn-wa" href={`https://wa.me/${biz.whatsapp}`} target="_blank" style={{marginTop:8,display:"inline-flex"}}>
            💬 {t.whatsapp}
          </a>
        </div>
        <div style={{background:"var(--bg)",borderRadius:"var(--rad)",minHeight:280,display:"flex",alignItems:"center",justifyContent:"center",flexDirection:"column",gap:10,border:"1px solid var(--light)"}}>
          <div style={{fontSize:44}}>🗺️</div>
          <div style={{textAlign:"center",color:"var(--mid)",fontSize:14,padding:"0 20px"}}>
            <strong style={{display:"block",marginBottom:5,color:"var(--dark)"}}>{biz.name}</strong>{biz.address}
          </div>
          <a className="btn btn-gh btn-sm" href={`https://maps.google.com?q=${encodeURIComponent(biz.address)}`} target="_blank">
            {lang==="es"?"Ver en Google Maps →":"View on Google Maps →"}
          </a>
        </div>
      </div>
    </div>
  );
}

function Dashboard({ t, lang, biz, setBiz, services, setServices, bookings, setBookings, toast_ }) {
  const [tab, setTab] = useState("cases");
  const tabs = [{id:"cases",label:t.dash_cases,icon:"📋"},{id:"services",label:t.dash_services,icon:"⚙️"},{id:"settings",label:t.dash_settings,icon:"🏢"}];
  return (
    <div className="sec">
      <div className="slabel">Admin</div>
      <h2 className="stitle">{t.owner_login}</h2>
      <div className="div"/>
      <div className="dw">
        <div className="dtabs">
          {tabs.map(tb=><button key={tb.id} className={`dtab ${tab===tb.id?"act":""}`} onClick={()=>setTab(tb.id)}>{tb.icon} {tb.label}</button>)}
        </div>
        <div className="dbody">
          {tab==="cases" && <Cases t={t} lang={lang} bookings={bookings} setBookings={setBookings} toast_={toast_} />}
          {tab==="services" && <Svcs t={t} lang={lang} services={services} setServices={setServices} toast_={toast_} />}
          {tab==="settings" && <Settings t={t} lang={lang} biz={biz} setBiz={setBiz} toast_={toast_} />}
        </div>
      </div>
    </div>
  );
}

function Cases({ t, lang, bookings, setBookings, toast_ }) {
  const statuses = ["pending","confirmed","inprogress","ready","done","cancelled"];
  const sl = {pending:t.status_pending,confirmed:t.status_confirmed,inprogress:t.status_inprogress,ready:t.status_ready,done:t.status_done,cancelled:t.status_cancelled};
  const update = (id,status) => { setBookings(bookings.map(b=>b.id===id?{...b,status}:b)); toast_(`${sl[status]}`); };
  const del = id => { setBookings(bookings.filter(b=>b.id!==id)); toast_(lang==="es"?"Caso eliminado.":"Case deleted."); };

  return (
    <div>
      <h3 style={{fontFamily:"'Fraunces',serif",marginBottom:22}}>{t.dash_cases} ({bookings.length})</h3>
      {bookings.length===0
        ? <div style={{textAlign:"center",padding:"36px 0",color:"var(--mid)"}}><div style={{fontSize:36}}>📋</div><p style={{marginTop:10}}>{t.no_bookings}</p></div>
        : <div style={{overflowX:"auto"}}>
            <table className="tbl">
              <thead><tr><th>Case #</th><th>{t.name}</th><th>{t.phone}</th><th>{t.service}</th><th>{t.date}</th><th>{t.time}</th><th>Status</th><th>{t.notes}</th><th>Actions</th></tr></thead>
              <tbody>
                {[...bookings].reverse().map(b=>(
                  <tr key={b.id}>
                    <td><strong style={{color:"var(--c)"}}>{b.caseNum}</strong></td>
                    <td><strong>{b.name}</strong><br/><span style={{fontSize:12,color:"var(--mid)"}}>{b.email}</span></td>
                    <td style={{whiteSpace:"nowrap"}}>{b.phone}</td>
                    <td>{b.service}</td>
                    <td style={{whiteSpace:"nowrap"}}>{b.date}</td>
                    <td style={{whiteSpace:"nowrap"}}>{b.time}</td>
                    <td>
                      <select value={b.status||"pending"} onChange={e=>update(b.id,e.target.value)}
                        style={{background:"var(--bg)",border:"1px solid var(--light)",borderRadius:6,padding:"4px 7px",fontSize:12,fontFamily:"'Sora',sans-serif",cursor:"pointer"}}>
                        {statuses.map(s=><option key={s} value={s}>{sl[s]}</option>)}
                      </select>
                    </td>
                    <td style={{maxWidth:110,fontSize:12,color:"var(--mid)"}}>{b.notes||"—"}{b.docs?.length>0&&<div style={{color:"var(--c)"}}>📎{b.docs.join(", ")}</div>}</td>
                    <td>
                      <div style={{display:"flex",gap:5}}>
                        <a className="btn btn-gh btn-sm" href={`https://wa.me/${b.phone?.replace(/\D/g,"")}?text=${encodeURIComponent((lang==="es"?"Hola "+b.name+", su caso ":"Hello "+b.name+", case ")+b.caseNum+(lang==="es"?" está listo.":" is ready."))}`} target="_blank">💬</a>
                        <button className="btn btn-del btn-sm" onClick={()=>del(b.id)}>🗑</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
      }
      <div style={{marginTop:20,background:"rgba(27,79,138,.06)",borderRadius:"var(--sm)",padding:"12px 16px",fontSize:13,color:"var(--mid)"}}>
        💬 {lang==="es"?"Haz clic en 💬 para contactar al cliente directamente por WhatsApp.":"Click 💬 to message the client directly on WhatsApp."}
      </div>
    </div>
  );
}

function Svcs({ t, lang, services, setServices, toast_ }) {
  const empty = {id:0,name:"",name_es:"",desc:"",desc_es:"",price:"",icon:"📄",active:true};
  const [adding, setAdding] = useState(false);
  const [form, setForm] = useState(empty);
  const save = () => {
    if (!form.name){toast_(lang==="es"?"Escribe el nombre.":"Enter service name.");return;}
    setServices([...services,{...form,id:Date.now()}]);
    setForm(empty);setAdding(false);
    toast_(lang==="es"?"¡Servicio agregado!":"Service added!");
  };
  const toggle = id => setServices(services.map(s=>s.id===id?{...s,active:!s.active}:s));
  const del = id => {setServices(services.filter(s=>s.id!==id));toast_(lang==="es"?"Eliminado.":"Deleted.");};

  return (
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:22}}>
        <h3 style={{fontFamily:"'Fraunces',serif"}}>{t.dash_services}</h3>
        <button className="btn btn-p btn-sm" onClick={()=>setAdding(!adding)}>+ {t.add_service}</button>
      </div>
      {adding && (
        <div className="fcard" style={{marginBottom:24}}>
          <div className="frow">
            <div className="fg"><label>{t.service_name} *</label><input value={form.name} onChange={e=>setForm({...form,name:e.target.value})} /></div>
            <div className="fg"><label>{t.service_name_es}</label><input value={form.name_es} onChange={e=>setForm({...form,name_es:e.target.value})} /></div>
          </div>
          <div className="frow">
            <div className="fg"><label>{t.service_desc}</label><textarea value={form.desc} onChange={e=>setForm({...form,desc:e.target.value})} style={{minHeight:56}} /></div>
            <div className="fg"><label>{t.service_desc_es}</label><textarea value={form.desc_es} onChange={e=>setForm({...form,desc_es:e.target.value})} style={{minHeight:56}} /></div>
          </div>
          <div className="frow">
            <div className="fg"><label>{t.service_price}</label><input value={form.price} onChange={e=>setForm({...form,price:e.target.value})} placeholder="From $50" /></div>
            <div className="fg"><label>{t.service_icon}</label><input value={form.icon} onChange={e=>setForm({...form,icon:e.target.value})} placeholder="📄" /></div>
          </div>
          <div style={{display:"flex",gap:10}}>
            <button className="btn btn-p" onClick={save}>✓ {t.save}</button>
            <button className="btn btn-gh" onClick={()=>setAdding(false)}>{t.cancel}</button>
          </div>
        </div>
      )}
      <div style={{display:"flex",flexDirection:"column",gap:9}}>
        {services.map(s=>(
          <div key={s.id} style={{display:"flex",alignItems:"center",gap:14,background:s.active?"var(--bg)":"rgba(0,0,0,.03)",border:"1px solid var(--light)",borderRadius:"var(--sm)",padding:"12px 16px",opacity:s.active?1:.55}}>
            <span style={{fontSize:22}}>{s.icon}</span>
            <div style={{flex:1}}><div style={{fontWeight:600,fontSize:14}}>{s.name} / {s.name_es||"—"}</div><div style={{fontSize:12,color:"var(--mid)"}}>{s.price}</div></div>
            <div style={{display:"flex",gap:7}}>
              <button className="btn btn-gh btn-sm" onClick={()=>toggle(s.id)}>{s.active?(lang==="es"?"Desactivar":"Deactivate"):(lang==="es"?"Activar":"Activate")}</button>
              <button className="btn btn-del btn-sm" onClick={()=>del(s.id)}>🗑</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function Settings({ t, lang, biz, setBiz, toast_ }) {
  const [form, setForm] = useState(biz);
  const save = () => { setBiz(form); toast_(t.saved); };
  return (
    <div style={{maxWidth:620}}>
      <h3 style={{fontFamily:"'Fraunces',serif",marginBottom:22}}>{t.settings_title}</h3>
      <div style={{display:"flex",gap:14,marginBottom:18}}>
        <div className="fg" style={{flex:1,marginBottom:0}}><label>{t.biz_logo}</label><input value={form.logo} onChange={e=>setForm({...form,logo:e.target.value})} maxLength={3} placeholder="CS" /></div>
        <div className="fg" style={{marginBottom:0}}><label>{t.biz_color}</label><input type="color" value={form.color||"#1B4F8A"} onChange={e=>setForm({...form,color:e.target.value})} style={{height:42,width:76,cursor:"pointer",borderRadius:8,border:"1.5px solid var(--light)",padding:2}} /></div>
      </div>
      <div className="fg"><label>{t.biz_name} *</label><input value={form.name} onChange={e=>setForm({...form,name:e.target.value})} /></div>
      <div className="frow">
        <div className="fg"><label>{t.biz_tagline}</label><input value={form.tagline} onChange={e=>setForm({...form,tagline:e.target.value})} /></div>
        <div className="fg"><label>{t.biz_tagline_es}</label><input value={form.tagline_es} onChange={e=>setForm({...form,tagline_es:e.target.value})} /></div>
      </div>
      <div className="frow">
        <div className="fg"><label>{t.biz_phone}</label><input value={form.phone} onChange={e=>setForm({...form,phone:e.target.value})} /></div>
        <div className="fg"><label>{t.biz_whatsapp}</label><input value={form.whatsapp} onChange={e=>setForm({...form,whatsapp:e.target.value})} placeholder="15550000000" /></div>
      </div>
      <div className="fg"><label>{t.biz_email}</label><input value={form.email} onChange={e=>setForm({...form,email:e.target.value})} /></div>
      <div className="fg"><label>{t.biz_address}</label><input value={form.address} onChange={e=>setForm({...form,address:e.target.value})} /></div>
      <div className="fg"><label>{t.biz_hours}</label><input value={form.hours} onChange={e=>setForm({...form,hours:e.target.value})} /></div>
      <button className="btn btn-p" onClick={save} style={{marginTop:8}}>✓ {t.save}</button>
      <div style={{marginTop:36,background:"rgba(27,79,138,.06)",borderRadius:"var(--rad)",padding:22,border:"1px dashed var(--c)"}}>
        <h4 style={{fontFamily:"'Fraunces',serif",marginBottom:9}}>📲 SMS / WhatsApp {lang==="es"?"Notificaciones":"Notifications"}</h4>
        <p style={{fontSize:13,color:"var(--mid)",lineHeight:1.7}}>
          {lang==="es"
            ?"Para recibir avisos automáticos cuando alguien reserve, conecta Twilio o usa Zapier con WhatsApp Business."
            :"To receive automatic alerts when someone books, connect Twilio or use Zapier with WhatsApp Business."}
        </p>
        <div style={{display:"flex",gap:9,marginTop:14,flexWrap:"wrap"}}>
          {[["Twilio","https://twilio.com"],["Zapier","https://zapier.com"],["WhatsApp Business","https://business.whatsapp.com"]].map(([n,u])=>(
            <a key={n} href={u} target="_blank" className="btn btn-gh btn-sm">{n} →</a>
          ))}
        </div>
      </div>
    </div>
  );
}
